import { render, staticRenderFns } from "./GuruKunjungan.vue?vue&type=template&id=8bcc8a68"
import script from "./GuruKunjungan.vue?vue&type=script&lang=js"
export * from "./GuruKunjungan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports